<template>
  <v-card flat>
    <v-form
      v-model="ok"
    >
      <v-container
        pt-4
        pb-0
      >
        <v-layout wrap>
          <TankSelect
            :tank-selection="tankSelection"
            :selected-id="id"
            :customer-id="customerId"
            @input="$emit('change-tank', $event)"
            @remove-new-tank="$emit('remove-new-tank')"
          />
          <v-flex
            xs12
            md7
            offset-md1
          >
            <v-text-field
              class="purple-input"
              label="最終更新時刻"
              disabled
              :value="volumeUpdatedAtText"
            />
          </v-flex>
          <v-flex
            xs6
            md5
          >
            <v-text-field
              class="purple-input"
              label="消費ペース"
              disabled
              :value="consumptionRate"
            />
          </v-flex>

          <v-flex
            v-if="id !== 'new'"
            xs6
            md5
            offset-md1
            style="cursor: pointer;"
            @click.stop.prevent="editSensor($event)"
          >
            <v-text-field
              v-model.trim="serialNo"
              class="purple-input serial-input"
              label="センサー"
              readonly
            />
            <SensorEditDialog
              v-model="showSensorDialog"
              :from="sensorInfo"
              :customer-id="customerId"
              :tank-id="id"
              :is-sensor-removal="isSensorRemoval"
              @toggleDialog="toggleSensorDialog"
              @update-sensor-info="$emit('update-sensor-info', $event)"
            />
            <SensorMenu
              v-model="showSensorMenu"
              :position="sensorMenuPos"
              @click="onSensorMenuClick($event)"
            />
          </v-flex>
        </v-layout>

        <v-divider
          class="mt-2 mb-3"
          style="margin: 12px 0px 18px !important;"
        />

        <v-layout wrap>
          <v-flex
            xs12
            md10
          >
            <TankTypeSelect
              v-model="tankType"
              @input="setMaxVolume"
            />
          </v-flex>
          <v-flex
            xs6
            md5
          >
            <NumberField
              v-model="volumeThreshold"
              class="purple-input"
              label="しきい値"
              :max="legalMaxVolume"
              :rules="['required']"
            />
          </v-flex>
          <v-flex
            xs6
            md5
          >
            <NumberField
              v-model="deliveryFrequency"
              class="purple-input"
              label="配送頻度"
              :rules="['required', 'above1']"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex
            class="text-xs-right"
            xs12
          >
            <v-btn
              color="success"
              :disabled="!ok || !dirty || loading"
              :loading="loading"
              @click="updateTank"
            >
              更新
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { epoch2timestamp } from '@/utils/time'
import { TankSelect, SensorEditDialog, SensorMenu } from './TankTab/index'
import { NumberField, TankTypeSelect } from '@/components/input'

const props = ['id', 'tankType', 'volumeThreshold', 'consumptionRate', 'serialNo', 'deliveryFrequency', 'volumeUpdatedAt', 'sensorInstalledAt', 'sensorId', 'legalMaxVolume']

export default {
  components: {
    TankSelect,
    SensorEditDialog,
    SensorMenu,
    NumberField,
    TankTypeSelect
  },
  props: {
    tanks: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      default: () => null
    },
    tankSelection: {
      type: Array,
      default: () => []
    },
    customerId: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      // tank data
      id: null,
      tankType: null,
      volumeThreshold: null,
      consumptionRate: null,
      serialNo: '',
      deliveryFrequency: 0,
      volumeUpdatedAt: null,
      sensorInstalledAt: null,
      sensorId: null,
      legalMaxVolume: 9999,
      /// ///
      ok: true,
      loading: false,
      showSensorMenu: false,
      sensorMenuPos: { x: 0, y: 0 },
      showSensorDialog: false,
      isSensorRemoval: false
    }
  },
  computed: {
    ...mapState('groups', ['group']),
    ...mapState('tankTypes', ['tankTypes']),
    isNewTank () {
      return this.id === 'new'
    },
    dirty () {
      if (!this.selected) return false
      return !props.every(prop => this.selected[prop] === this[prop])
    },
    sensorInfo () {
      if (!this.sensorId) {
        return null
      }
      return {
        id: this.sensorId,
        serialNo: this.serialNo,
        sensorInstalledAt: this.sensorInstalledAt
      }
    },
    volumeUpdatedAtText () {
      return this.volumeUpdatedAt
        ? epoch2timestamp(this.volumeUpdatedAt)
        : '未取得'
    }
  },
  watch: {
    selected (value) {
      props.forEach(prop => { this[prop] = value[prop] })
    }
  },
  mounted () {
    props.forEach(prop => { this[prop] = this.selected[prop] })
  },
  methods: {
    ...mapMutations('app', ['setGlobalSnackBarText']),
    ...mapActions('customers', ['updateCustomerTank', 'createCustomerTank']),
    editSensor (e) {
      if (!this.serialNo) {
        this.showSensorDialog = true
        return
      }
      this.sensorMenuPos = { x: e.clientX, y: e.clientY }
      this.$nextTick(() => {
        this.showSensorMenu = true
      })
    },
    toggleSensorDialog () {
      this.showSensorDialog = false
      this.isSensorRemoval = false
    },
    onSensorMenuClick (index) {
      if (index === 1) this.isSensorRemoval = true
      this.showSensorDialog = true
    },
    setMaxVolume (id) {
      const tankType = this.tankTypes.find(tt => tt.id === id)
      this.legalMaxVolume = tankType
        ? tankType.tankMaxVolume
        : null

      this.volumeThreshold = this.volumeThreshold !== null
        ? Math.min(this.volumeThreshold, this.legalMaxVolume)
        : null
    },
    async updateTank () {
      if (!this.ok) {
        return
      }
      this.loading = true

      const data = {
        customerId: this.customerId,
        tankId: this.id,
        reqData: {
          serialNo: this.serialNo,
          tankType: this.tankType,
          remarks: '',
          volumeThreshold: this.volumeThreshold,
          deliveryFrequency: this.deliveryFrequency
        }
      }

      try {
        if (this.id === 'new') {
          const id = await this.createCustomerTank(data)
          this.$emit('change-tank', id)
          this.setGlobalSnackBarText(`タンクID：${id}を追加しました。`)
        } else {
          await this.updateCustomerTank(data)
          this.$emit('reset')
          this.setGlobalSnackBarText(`タンクID：${this.id}を更新しました。`)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.serial-input {
  pointer-events: none;
}
</style>
